import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { CalendarRange, Label } from "../../../../components/Inputs";
import { PrimaryButton, SecondaryButton } from "../../../../components/Buttons";


function LoginBehaviorFilter({ reportInterval, filterReport }) {
  const [interval, setInterval] = React.useState(reportInterval || []);
  const [selectedStart, setSelectedStart] = React.useState(null);

  const minPossibleDate = moment("20.04.2026", "DD.MM.YYYY");
  const minDate = moment.max(minPossibleDate, moment().subtract(2, "years"));
  const today = moment().startOf("day");

  // Calculate dynamic maxDate based on selected start date
  const getMaxDate = () => {
    if (selectedStart) {
      const maxFromStart = moment(selectedStart).add(2, "years");
      return moment.min(maxFromStart, today).toDate();
    }
    // console.log("getMaxDate: selectedStart is null, returning today");
    return today.toDate();
  };

  React.useEffect(() => {
    if (reportInterval && reportInterval.length === 2) {
      setInterval(reportInterval);
      setSelectedStart(reportInterval[0]);
    }
  }, [reportInterval]);

  const handleChange = React.useCallback((event) => {
    // const [start, end] = event.value;
    let start = null;
    let end = null;
    if (event && event.value && Array.isArray(event.value) && event.value.length === 2) {
      [start, end] = event.value;
    }

    // Track selected start date for dynamic maxDate
    if (start) {
      setSelectedStart(start);
    }

    if (end) {
      const maxFromStart = moment(start).add(2, "years");
      let newEnd = moment.min(moment(end), maxFromStart).toDate();
      setInterval([start, newEnd]);
    } else {
      setInterval([start || selectedStart, null]);
    }
  }, [selectedStart]);

  const handleClick = () => {
    filterReport(interval);
  };

  const handleReset = () => {
    const start = moment.max(minDate, today.clone().subtract(2, "years"));
    const defaultInterval = [start.toDate(), today.toDate()];
    setInterval(defaultInterval);
    setSelectedStart(start.toDate());
    filterReport(defaultInterval);
  };

  const handleClear = () => {
    // Reset selectedStart so maxDate becomes today (constraint-free)
    setSelectedStart(null);
    setInterval([]);
  };

  // Determine if "Heute" button should be disabled
  const isHeuteDisabled = () => {
    if (!selectedStart) return false;
    const maxFromStart = moment(selectedStart).add(2, "years");
    return maxFromStart.isBefore(today);
  };
  
  return (
    <div className="pad-big w3-border-left w3-border-right w3-light-grey">
      <div className="w3-cell-row">
        <div className="w3-cell w3-cell-middle" style={{width: "190px"}}>
          <Label htmlFor="interval">{`Zeitinterval (von - bis)`}</Label>
        </div>
        <div className="w3-rest">
          <CalendarRange
            id="interval"
            className="w3-block w3-border w3-round"
            value={interval}
            readOnlyInput={true}
            dateFormat="dd.mm.yy"
            maxDate={getMaxDate()}
            minDate={minDate.toDate()}
            onChange={handleChange}
            onClear={handleClear}
            isHeuteDisabled={isHeuteDisabled()}
          />
        </div>
        <div className="w3-cell w3-cell-middle alg-rht" style={{ width: "280px" }}>
          <SecondaryButton
            className="w3-margin-right"
            size="small"
            onClick={handleReset}
            style={{ height: "38.5px" }}
          >
            {`Zurücksetzen`}
          </SecondaryButton>
          <PrimaryButton
            size="small"
            onClick={handleClick}
            disabled={!interval || interval.length !== 2}
            style={{ height: "38.5px" }}
          >
            {`Aktualisieren`}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

LoginBehaviorFilter.propTypes = {
  reportInterval: PropTypes.array,
  filterReport: PropTypes.func.isRequired,
};

export default LoginBehaviorFilter;
